import { useMe } from '@/features/authentication/_hooks/me';

export const useCommentEditPermission = (
  commentAuthorId: string | undefined,
) => {
  const { data: me } = useMe();
  return me?.id === commentAuthorId;
};
